import React, { useEffect } from "react";
import DashboardBarChart from "../../../components/adminRole/dashboard/DashboardBarChart";
import { useSelector, useDispatch } from "react-redux";
import { getDashboardTrainingStatusRunningGraph } from "../../../appRedux/actions";
import FilterBarChartParticipant from "../../../components/adminRole/dashboard/FilterBarChartParticipant";

export default function BarChartTrainingRunning({ locations }) {

  const dispatch = useDispatch();
  const { trainingStatusRunningGraph, trainingStatusRunningGraphFilter } =
    useSelector(({ dashboard }) => dashboard);

  useEffect(() => {
    dispatch(
      getDashboardTrainingStatusRunningGraph(trainingStatusRunningGraphFilter)
    );
  }, []);

  const handleChangeType = (filter, dates) => {
    dispatch(getDashboardTrainingStatusRunningGraph(filter, dates));
  };

  const getTrainingStatusRunData = () =>
  trainingStatusRunningGraph.map(function (training) {
      return {
        name: training.training_option_name,
        training_berjalan: training.total_training_running,
      };
    });

  return (
    <>
      <FilterBarChartParticipant
        value={trainingStatusRunningGraphFilter}
        onChange={handleChangeType}
        locations={locations}
      />
      <DashboardBarChart
        barKey="training_berjalan"
        fillColor="#6db7ff"
        data={getTrainingStatusRunData()}
        barName="Training Berjalan"
      />
    </>
  );
}
